import angular from 'angular';

const InvoicesServiceFactory = ($log, NewBackendService, $q, endPoints, NewTokenService, UserHelperService) => {
  'ngInject';


  const data = {
    userContext: {},
    data: {
      request: {
        getListaMovimentiRequest: {
          isInstrumentCard: false,
          pagination: {
            elementiPerPagina: 1000
          },
          isCreditNote: true,
          ignoreIdMerchantDevice: true,
          profileFilter: 2,
          isInvoice: true
        }
      }
    }
  };
  const request = data.data.request.getListaMovimentiRequest;

  const backendCall = (req, wallet) => $q((resolve, reject) => {
    if ((NewTokenService.isMerchantTypeCorporate() || NewTokenService.isMerchantTypeDouble()) && UserHelperService.isLevel2()) {
      const URL = 'movimenti/getListaMovimenti';
      const tipo = 'merchant';

      req.data.request.getListaMovimentiRequest.idStrumento = wallet; // eslint-disable-line
      NewBackendService.invokeWebApiPost(URL, req, true).then(
        (res) => {
          if (res.data.response.getListaMovimentiResponse != null) {
            let resultList = res.data.response.getListaMovimentiResponse.listaMovimenti;
            if (resultList === undefined) {
              resultList = [];
            }

            angular.forEach(resultList, (record) => {
              record.amount = record.amount / 100.0; // eslint-disable-line
              record.fee = (record.fee || 0) / 100.0;
              record.contact = record.contactName || record.contactSurname ? `${record.contactName} ${record.contactSurname}` : undefined; // eslint-disable-line
              record.direction = record.movementType === 'INCOMING' ? 'in' : 'out'; // eslint-disable-line
              record.checked = false; // eslint-disable-line
              record.pdfUrl =  `/${tipo}/${record.transactionId}`;// eslint-disable-line
            });

            resolve(resultList);
          } else {
            reject('null resultList');
          }
        },
        (reason) => {
          reject(reason);
        });
    } else {
      const URL = 'wallet/getWalletTransactionList';
      const tipo = 'merchant';

      const request = {
        "data": {
          "dtoReq": {
            "dtoGetWalletTransactionListReq": {
              "idUserInstrument": wallet,
              "dtoPagination": {
                "elementPerPage": 1000,
                "indexPage": 1
              },
              "invoice": true,
              "creditNote": true,
              "walletMovementType": 2,
              "dateFrom": req.dataDa,
              "dateTo": req.dataA
            }
          }
        },
        "userContext": {}
      };

      NewBackendService.invokeWebApiPost(URL, request, true).then(
        (res) => {
          if (res.data.dtoRes.dtoGetWalletTransactionListRes != null) {
            let resultList = res.data.dtoRes.dtoGetWalletTransactionListRes.dtoWalletTransactionFullList;
            if (resultList === undefined) {
              resultList = [];
            }

            angular.forEach(resultList, (record) => {
              record.amount = record.amount / 100.0; // eslint-disable-line
              record.fee = (record.fee || 0) / 100.0;
              record.contact = record.contactName || record.contactSurname ? `${record.contactName} ${record.contactSurname}` : undefined; // eslint-disable-line
              record.direction = record.movementType === 'INCOMING' ? 'in' : 'out'; // eslint-disable-line
              record.checked = false; // eslint-disable-line
              record.pdfUrl =  `/${tipo}/${record.idTransaction}`;// eslint-disable-line
            });

            resolve(resultList);
          } else {
            reject('null resultList');
          }
        },
        (reason) => {
          reject(reason);
        });
    }
  });


  const service = {
    getInvoicesAndNotes: (dataDa, dataA, wallet) => $q((resolve, reject) => {
      request.isCreditNote = true;
      request.isInvoice = true;
      if (dataDa !== undefined && dataA !== undefined) {
        request.dataDa = dataDa;
        request.dataA = dataA;
      } else {
        delete request.dataDa;
        delete request.dataA;
      }

      backendCall(data, wallet).then((list) => {
        resolve(list);
      }, (err) => {
        reject(err);
      });
    }),

    getInvoices: (dataDa, dataA, wallet) => $q((resolve, reject) => {
      request.isCreditNote = false;
      request.isInvoice = true;
      if (dataDa !== undefined && dataA !== undefined) {
        request.dataDa = dataDa;
        request.dataA = dataA;
      }

      backendCall(data, wallet).then((list) => {
        resolve(list);
      }, (err) => {
        reject(err);
      });
    }),

    getNotes: (dataDa, dataA, wallet) => $q((resolve, reject) => {
      request.isCreditNote = true;
      request.isInvoice = false;
      if (dataDa !== undefined && dataA !== undefined) {
        request.dataDa = dataDa;
        request.dataA = dataA;
      }

      backendCall(data, wallet).then((list) => {
        resolve(list);
      }, (err) => {
        reject(err);
      });
    }),

    showPdf: (urlPdf) => {
      const url = `${endPoints.webApiUrl}static-assets/documents/invoice-creditnote${urlPdf}`;
      window.open(url, '_blank');
    },

    makeZip: (invoiceListChecked) => {
      let idString = '';
      angular.forEach(invoiceListChecked, (record) => {
        idString = `${idString};${record.idTransaction}`;
      });
      const url = `${endPoints.webApiUrl}static-assets/documents/invoice-creditnote/asZip/invoiceCreditNoteList${idString}`;
      $log.debug('url chiamato  = ', url);
      window.open(url, '_blank');
    }
  };

  return service;
};

export default InvoicesServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/invoices.factory.js
 **/